import { useModals } from '@/modules/drivers/stores/modalsStore'
import React from 'react'

import Tooltip from '../../ToolTip'
import useDriverService from '@/modules/drivers/services/DriverService'
import DeactivateColor from '../../../../../assets/icons_new/DeActivateColor.svg'
import ActivateColor from '../../../../../assets/icons_new/ActivateColor.svg'
import { useDrivers } from '@/modules/shared/context/drivers/DriversContext'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { useSideSelectionStore } from '@/modules/drivers/stores/sideSelectionStore'
import { useHasAccess } from '@/modules/shared/permissions'

const DriverActions = ({
  selectedGroup,
  companyId,
  onReset,
}: {
  selectedGroup: any
  companyId: string
  onReset?: () => void
}) => {
  const { t } = useLocalize()
  const { setIsDeactivateOpen, setIsOpenEditDriverModal } = useModals()
  const { refresh } = useDrivers()
  const { activateDriver } = useDriverService()
  const { sideCheckedIds } = useSideSelectionStore()
  const { allowed: canEditDrivers } = useHasAccess({ permissions: 'canAddDriver' }, companyId)
  const isAnySelected = sideCheckedIds.length > 0 && canEditDrivers
  return (
    <div className="tw-flex tw-items-center tw-gap-5">
      {selectedGroup?.isActive ? (
        <Tooltip
          disabled={!isAnySelected}
          text={t('driverModule.deactivate')}
          onClick={() => {
            setIsDeactivateOpen(true)
          }}
        >
          <img src={DeactivateColor} alt="Deactivate User" />
        </Tooltip>
      ) : (
        <Tooltip
          disabled={!isAnySelected}
          text={t('driverModule.activate')}
          onClick={() =>
            activateDriver({
              companyId,
              driversIds: selectedGroup?.ids,
              setActive: true,
            }).finally(() => {
              refresh()
            })
          }
        >
          <img src={ActivateColor} alt="Activate User" />
        </Tooltip>
      )}
    </div>
  )
}

export default DriverActions
